import { render, staticRenderFns } from "./Update-Single-Person-Individual-Customer.vue?vue&type=template&id=770c0706"
import script from "./Update-Single-Person-Individual-Customer.vue?vue&type=script&lang=js"
export * from "./Update-Single-Person-Individual-Customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports